<template>
  <main id="cats">
    <breadcrumb :title="cats.title" subTitle=""/>
    <detail :prod="product" v-if="prodShow" class="detailContent" :style="{maxHeight: ph}" />
    <div class="close" @click="closeProd()" v-if="prodShow">
      <i class="fal fa-times closeBtn"></i>
    </div>
    <div class="bd-services-2__area  pt-30 pb-90">
      <template v-for="gitem in group.slice().reverse()">
        <div class="container-fluid parallaxConatin"  v-lazy:background-image="{src: gitem.img,error: require('@/assets/lazyG.png'),loading:  require('@/assets/lazyG.png')}"
             style="background-position: center center;min-height: 300px">
        </div>
        <div class="container">
          <div class="row">
            <template v-for="item in products.slice().reverse()">
              <div class="col-lg-4 col-md-6 item hover-switch" @click="openProd(item)" v-if="item.prodgroup == gitem.id">
                <div class="bd-services-2__item text-center mb-30 wow fadeInUp product">
                  <div class="img">
                    <img v-lazy="item.img[1]" class="img-fluid" :alt="item.title">
                    <img v-lazy="item.img[0]" class="img-fluid" :alt="item.title">
                  </div>
                  <h3 class="bd-services-2__title">{{ item.title }}</h3>
                  <div class="bd-services-2__content">
                    <div class="bd-services-2__item-btn">
                      <a href="javascript:void(0);" class="link-btn-2">
                        İncele
                        <i class="fas fa-angle-right"></i>
                        <i class="fas fa-angle-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
    <app-footer/>
  </main>
</template>
<script>
import breadcrumb from "@/components/Common/Breadcrumb";
import detail from "@/components/Common/Detail";
import appFooter from "@/components/Common/Footer";
import axiosCustom from "@/axiosCustom";

export default {
  name: 'App',
  components: {breadcrumb, detail,appFooter},
  data() {
    return {
      cats:[],
      group:[],
      products: [],
      product: [],
      ph: '0vh',
      bg: 'url('+require('@/assets/detailBg.png')+')',
      prodShow: false,
      openItem: null,
    }
  },
  created() {
   this.pGet()
  },
  methods: {
    pGet(){
      axiosCustom
          .get('cats/'+this.$route.params.catName)
          .then(response => {
            this.cats = response.data
            document.title = this.cats.title

            axiosCustom
                .get('prodgroup')
                .then(response => {
                  this.group = response.data.filter(c => c.cat === this.cats.id)
                  axiosCustom
                      .get('products')
                      .then(response => {
                        this.products = response.data
                      })
                      .catch(error => {
                        console.log(error);
                      })
                })
                .catch(error => {
                  console.log(error);
                })
          })
          .catch(error => {
            console.log(error);
          })
    },
    openProd(e) {
      this.product.push({
        productTitle: e.title,
        productBarcode: e.barcode,
        productContents: e.contents,
        productAroma: e.aroma,
        productLife: e.life,
        productDetail: e.desc,
        productImages: e.img,
        productTableTitle: e.tabletitle,
        productTable: e.tablee,
        productTableDesc: e.tabledesc,
        productActive: 0
      })
      this.prodShow = true
      setTimeout(() => {
        this.ph = 'auto'
      }, 100)
    },
    closeProd() {
      this.ph = '0vh'
      setTimeout(() => {
        this.prodShow = false
        this.product = []
      }, 300)
    }
  },
  watch:{
    $route (to, from){
      if (to.fullPath == '/anasayfa' | to.fullPath == '/kurumsal' | to.fullPath == '/iletisim'){
    // title fix
      }else{
        document.body.style.overflow = 'auto';
        window.scrollTo(0, 0);
        this.pGet()

      }
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
    document.body.style.overflow = 'auto';
    if (this.openItem != null) {
      this.closeProd()
    }
    window.scrollTo(0, 0);
  },
  beforeRouteEnter(to, from, next) {
    next();
    document.body.style.overflow = 'auto';
    window.scrollTo(0, 0);
  }
}
</script>
